var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M16.2 26.9l5.5-5.5 5.6 5.5M21.7 23.8v12.7M9.9 15.3c-3 0-5.3 2.3-5.3 5.2s2.3 5.2 5.2 5.2M18 13.2c-.5-1.7-2.1-2.9-4-2.9-2.3 0-4.2 1.9-4.2 4.2 0 .3 0 .6.1.8M31.7 15.4c.3-.1.6-.1 1-.1 2.9 0 5.2 2.3 5.2 5.2s-2.3 5.2-5.2 5.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M18 13.2v-.1C18 9.2 21.2 6 25.1 6s7.1 3.2 7.1 7.1c0 .8-.1 1.6-.4 2.3M9.9 15.3c-3 0-5.3 2.3-5.3 5.2s2.3 5.2 5.2 5.2M18 13.2c-.5-1.7-2.1-2.9-4-2.9-2.3 0-4.2 1.9-4.2 4.2 0 .3 0 .6.1.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M31.7 15.4c.3-.1.6-.1 1-.1 2.9 0 5.2 2.3 5.2 5.2s-2.3 5.2-5.2 5.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M18 13.2v-.1C18 9.2 21.2 6 25.1 6s7.1 3.2 7.1 7.1c0 .8-.1 1.6-.4 2.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSimple);
export default __webpack_public_path__ + "static/media/uploadSimple.748e0f3cc8e1b673c68db501f9131f3d.svg";
export { ForwardRef as ReactComponent };